type KeycloakConfig = {
  url: string
  realm: string
  clientId: string
  redirectUri: string
}

export class KeycloakConfigError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "KeycloakConfigError"
  }
}

const KEYCLOAK_ENV_VARS = {
  url: "VITE_KEYCLOAK_URL",
  realm: "VITE_KEYCLOAK_REALM",
  clientId: "VITE_KEYCLOAK_CLIENT_ID",
  redirectUri: "VITE_KEYCLOAK_REDIRECT_URI",
} as const

type KeycloakEnvKey = keyof typeof KEYCLOAK_ENV_VARS

const readEnv = (key: KeycloakEnvKey): string => {
  const envName = KEYCLOAK_ENV_VARS[key]
  const value = import.meta.env[envName]
  if (!value || value.trim().length === 0) {
    throw new KeycloakConfigError(
      `[Keycloak] Variabile d'ambiente mancante o vuota: ${envName}. Verifica .env.local o le env del deploy.`,
    )
  }
  return value.trim()
}

let cachedConfig: KeycloakConfig | null = null

export const getKeycloakConfig = (): KeycloakConfig => {
  if (cachedConfig) return cachedConfig
  cachedConfig = {
    url: readEnv("url"),
    realm: readEnv("realm"),
    clientId: readEnv("clientId"),
    redirectUri: readEnv("redirectUri"),
  }
  return cachedConfig
}

export type { KeycloakConfig }
